import { render } from "./VideoControls.vue?vue&type=template&id=64f75d43&scoped=true&ts=true"
import script from "./VideoControls.vue?vue&type=script&lang=ts"
export * from "./VideoControls.vue?vue&type=script&lang=ts"

import "./VideoControls.vue?vue&type=style&index=0&id=64f75d43&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f75d43"]])

export default __exports__